import { __awaiter } from 'tslib';
import React, { useEffect } from 'react';
import '../../../../../services/base/baseDiscoverService.js';
import '../../../../../services/base/baseV3Service.js';
import '../../../../../services/base/baseInsightsService.js';
import '../../../../../services/sgtService.js';
import '@analytics/storage-utils';
import 'date-fns/format';
import 'date-fns/secondsToMinutes';
import 'date-fns/isValid';
import 'date-fns/addMinutes';
import 'date-fns';
import 'date-fns-tz';
import { useError } from '../../../../../utils/ErrorProvider.js';
import { useLoader } from '../../../../../utils/LoaderProvider.js';
import { useRefetch } from '../../../../../utils/RefetchProvider.js';
import '../../../../../utils/NotificationProvider.js';
import '../../../../../utils/ContactProvider.js';
import '../../../../../utils/PolicyProvider.js';
import '../../../../../utils/AnalyticsProvider.js';
import '../../../../../types/AccessDevice.js';
import '../../../../../types/Analytics.js';
import '../../../../../types/CASACommunity.js';
import '../../../../../types/Community.js';
import '../../../../../types/DxSettings.js';
import '../../../../../types/MagicButton.js';
import '../../../../../types/Pannellum.js';
import '../../../../../types/Prospect.js';
import '../../../../../types/ProspectIntelligence.js';
import '../../../../../types/Space.js';
import '../../../../../types/Tour.js';
import '../../../../../utils/analyticsPlugin.js';
import '../../../../../utils/communityGoogleAnalyticsPlugin.js';
import 'qs';
import '../../../../../utils/cookieUtils.js';
import '../../../../../utils/termsConditionsAgreementsUtils.js';
import '../../../../../services/base/analyticsV2BaseService.js';
import 'axios';
import '../../../../../services/base/internalApiBaseService.js';
import { uploadFileToPreSignedURL } from '../../../../../services/uploadService.js';
import '../../../../../services/base/casaBaseService.js';
import '../../../../../services/scanRequestsService.js';
import '../../../../../services/db/insightsReportsDB.js';
import '../../../../../services/aiDiscoverability.js';
import 'dot-object';
import '../../../../../apis/analytics/useDownloadAnalyticsReports.js';
import { useUploadStagedImage } from '../../../../../apis/space/useUploadStagedImage.js';
import { useSignedURL, SIGNED_URL_UPLOAD_TYPE } from '../../../../../apis/upload/useSignedURL.js';
import { PeekDialog, PeekImageSelector } from '@piiqtechnologies/ui-components';
import { usePannellumViewer } from '../../../../components/pannellum-viewer/PannellumProvider.js';

const UploadStagedImageTool = ({ open, onClose }) => {
    const [image, setImage] = React.useState();
    const { getConfig, getYaw, details, setViewerContext } = usePannellumViewer();
    const [getSpaceUploadURL] = useSignedURL();
    const [uploadStagedImage, updatedSpace, updateSpaceNodeInProgress, updateSpaceNodeError] = useUploadStagedImage();
    const { name, nodeId } = getConfig();
    const { setError } = useError();
    const { setLoader } = useLoader();
    const { setRefetch } = useRefetch();
    const onChange = (img) => {
        setImage(img);
        handleUpload(img.file);
    };
    const handleUpload = (file) => __awaiter(void 0, void 0, void 0, function* () {
        const maxRetries = 3;
        setLoader(true, "uploadingStagedImage");
        const uploadWithRetry = (file_1, ...args_1) => __awaiter(void 0, [file_1, ...args_1], void 0, function* (file, retries = 0) {
            try {
                const fileName = `${details._id}/${name}_STAGED.${file.name.split(".").pop()}`;
                const spaceUploadURL = yield getSpaceUploadURL({
                    uploadType: SIGNED_URL_UPLOAD_TYPE.SPACE,
                    fileName,
                });
                yield uploadFileToPreSignedURL(spaceUploadURL, file);
                return fileName;
            }
            catch (error) {
                if (retries < maxRetries) {
                    return uploadWithRetry(file, retries + 1);
                }
                else {
                    throw error;
                }
            }
        });
        const result = yield uploadWithRetry(file);
        setLoader(false, "uploadingStagedImage");
        uploadStagedImage({
            spaceId: details._id,
            nodeId,
            stagedPhoto: {
                url: result,
                lowResUrl: result,
            },
        });
    });
    useEffect(() => {
        if (updatedSpace) {
            setViewerContext({ details: updatedSpace });
            setRefetch({ sceneId: nodeId });
            onClose();
        }
    }, [updatedSpace]);
    useEffect(() => {
        if (updateSpaceNodeError) {
            setError(updateSpaceNodeError === null || updateSpaceNodeError === void 0 ? void 0 : updateSpaceNodeError.message);
        }
    }, [updateSpaceNodeError]);
    useEffect(() => {
        setLoader(updateSpaceNodeInProgress, "updateSpaceNode");
        return () => setLoader(false, "updateSpaceNode");
    }, [updateSpaceNodeInProgress]);
    return (React.createElement(PeekDialog, { open: open, sx: { position: "absolute", zIndex: 9999 }, maxWidth: "xs", onClose: onClose, fullWidth: true, PaperProps: { sx: { p: 2 } } },
        React.createElement(PeekImageSelector, { acceptType: ["jpg", "jpeg", "png"], value: ((image === null || image === void 0 ? void 0 : image.dataURL) && image) || null, onChange: onChange, uploadTitle: "Staged image", description: `Please, select the staged image for ${name}` })));
};

export { UploadStagedImageTool };
